import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createAiSearchBaseActions, createAiSearchStore, initialAiSearchBaseState } from '~/hooks/reactQuery/createAiSearchStore';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { withNetTerms } from '../settings-predicates';
import { clearGroupArms, setFilterField, toggleGroupConnector, updateOrArm } from './draftsFilterEdits';
const store = createAiSearchStore([
    QueryKeys.DraftsAiSearchState
], initialAiSearchBaseState());
const toFilterUpdate = (nextFilter)=>nextFilter == null ? {
        filter: null,
        lastQuery: ''
    } : {
        filter: nextFilter
    };
const markFilterEdited = (update)=>_object_spread_props(_object_spread({}, update), {
        filterEditedSinceLastSearch: true
    });
const editField = (state, key, value)=>state.filter == null ? {} : markFilterEdited(toFilterUpdate(setFilterField(state.filter, key, value)));
const actions = _object_spread_props(_object_spread({}, createAiSearchBaseActions(store)), {
    setAgreementName: (predicate)=>store.setState((s)=>editField(s, 'agreementName', predicate)),
    setClientName: (predicate)=>store.setState((s)=>editField(s, 'clientName', predicate)),
    setContactName: (predicate)=>store.setState((s)=>editField(s, 'contactName', predicate)),
    setStatus: (predicate)=>store.setState((s)=>editField(s, 'status', predicate)),
    setEffectiveDate: (predicate)=>store.setState((s)=>editField(s, 'effectiveDate', predicate)),
    setEffectiveDateMode: (predicate)=>store.setState((s)=>editField(s, 'effectiveDateMode', predicate)),
    setLastUpdatedAt: (predicate)=>store.setState((s)=>editField(s, 'lastUpdatedAt', predicate)),
    setLastModifiedBy: (predicate)=>store.setState((s)=>editField(s, 'lastModifiedBy', predicate)),
    setContactId: (predicate)=>store.setState((s)=>editField(s, 'contactId', predicate)),
    setNetTerms: (predicate)=>store.setState((s)=>editField(s, 'paymentSettings', s.filter == null ? undefined : withNetTerms(s.filter.paymentSettings, predicate))),
    setPaymentSettings: (predicate)=>store.setState((s)=>editField(s, 'paymentSettings', predicate)),
    setAgreementSettings: (predicate)=>store.setState((s)=>editField(s, 'agreementSettings', predicate)),
    setServices: (predicate)=>store.setState((s)=>editField(s, 'services', predicate)),
    setPackages: (predicate)=>store.setState((s)=>editField(s, 'packages', predicate)),
    setBundles: (predicate)=>store.setState((s)=>editField(s, 'bundles', predicate)),
    setOrArm: (index, arm)=>store.setState((s)=>{
            if (s.filter == null) return {};
            const result = updateOrArm(s.filter, index, arm);
            return result === undefined ? {} : markFilterEdited(toFilterUpdate(result));
        }),
    toggleConnector: ()=>store.setState((s)=>{
            if (s.filter == null) return {};
            const result = toggleGroupConnector(s.filter);
            return result === undefined ? {} : markFilterEdited({
                filter: result
            });
        }),
    clearGroup: ()=>store.setState((s)=>{
            if (s.filter == null) return {};
            const result = clearGroupArms(s.filter);
            return result === undefined ? {} : markFilterEdited(toFilterUpdate(result));
        })
});
export const useDraftsAiSearchStore = Object.assign((selector)=>store.useStore((data)=>selector(_object_spread({}, data, actions))), {
    getState: ()=>_object_spread({}, store.getState(), actions),
    setState: store.setState
});
